import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';

const ThanksPage = ((props, ref) => {
  return (
    <Container>
      <Box sx={{ marginY: 2}}>
        <Typography
          variant="h5"
          sx={{
          margin: '1rem 0',
          paddingLeft: '10px',
          borderLeft: 'solid 3px blue',
          fontWeight: 'bold',
          lineHeight: '3rem',
          height: '2.8rem',
          backgroundColor: 'divider',
          fontSize: { xs: '1.2rem', sm: '1.5rem' },
          }}
        >
          試験終了
        </Typography>

        <Box sx={{ padding: { xs: '0 1rem', sm: '0 2rem' }, height: { xs: 'auto', sm: 'auto' }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography textAlign="center" sx={{ paddingTop: { xs: 0, sm: '6rem' }, mb: { xs: '2.5rem'}, fontSize: { xs: '1.2rem', sm: '1.7rem' }, fontWeight: 'bold' }}>
            お疲れ様でした。以上で終了となります。<br />
            選考の結果は、担当者よりご連絡させていただきます。
          </Typography>
        </Box>
      </Box>
    </Container>
  );
});

export default ThanksPage;